export default {"src":"/_next/static/media/baby.cbe0b1d6.svg","height":213,"width":170};